import { useEffect, useState } from "react";
import api from "../../lib/api";
import { Trash2, Check, Mail, Phone } from "lucide-react";
import { toast } from "sonner";

export default function AdminMessages() {
  const [items, setItems] = useState([]);
  const load = async () => { const r = await api.get("/admin/contact-submissions"); setItems(r.data); };
  useEffect(() => { document.title = "Admin · Messages"; load(); }, []);

  const markRead = async (id) => { await api.put(`/admin/contact-submissions/${id}/read`); load(); };
  const remove = async (id) => {
    if (!window.confirm("Delete this message?")) return;
    await api.delete(`/admin/contact-submissions/${id}`); toast.success("Deleted"); load();
  };

  return (
    <div data-testid="admin-messages">
      <h1 className="font-serif text-3xl font-bold mb-2">Contact messages</h1>
      <p className="text-[#0a0d12]/60 text-sm mb-6">Submissions from the public contact form.</p>

      <div className="space-y-3">
        {items.map((m) => (
          <div key={m.id} className={`bg-white rounded-xl border ${m.is_read ? "border-black/5" : "border-[#d6aa43]/40"} p-5`} data-testid={`message-${m.id}`}>
            <div className="flex items-start justify-between gap-3 flex-wrap">
              <div>
                <div className="flex items-center gap-2 mb-1">
                  <span className="font-semibold text-[#0a0d12]">{m.name}</span>
                  <span className="text-xs px-2 py-0.5 rounded bg-[#f8f4e8] text-[#0d1724] uppercase tracking-wide">{m.reason}</span>
                  {!m.is_read && <span className="text-xs px-2 py-0.5 rounded bg-[#d6aa43] text-[#0a0d12] font-bold">NEW</span>}
                </div>
                <div className="text-xs text-[#0a0d12]/60 flex flex-wrap gap-3">
                  <span className="flex items-center gap-1"><Mail size={11} /> {m.email}</span>
                  {m.phone && <span className="flex items-center gap-1"><Phone size={11} /> {m.phone}</span>}
                  <span>{new Date(m.created_at).toLocaleString()}</span>
                </div>
              </div>
              <div className="flex gap-1">
                {!m.is_read && <button onClick={() => markRead(m.id)} className="p-1.5 hover:bg-green-50 text-green-700 rounded" title="Mark as read"><Check size={14} /></button>}
                <button onClick={() => remove(m.id)} className="p-1.5 hover:bg-red-50 text-red-600 rounded"><Trash2 size={14} /></button>
              </div>
            </div>
            <p className="mt-3 text-[#0a0d12]/80 text-sm whitespace-pre-wrap">{m.message}</p>
          </div>
        ))}
        {items.length === 0 && <p className="text-[#0a0d12]/50">No messages yet.</p>}
      </div>
    </div>
  );
}
